import {
    Box,
    Button,
    Card,
    Grid,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";
import customerActions from "../../redux/customer/actions";
import PreferenceWiseTableForAllCourses from "../../common/preferenceWiseTableForAllCourses";

export default function Index() {
  const dispatch = useDispatch();
  const [preference, setPreference] = useState(1);
  const preferencesno = [
    { name: "Preference 1", value: 1 },
    { name: "Preference 2", value: 2 },
    { name: "Preference 3", value: 3 },
    { name: "Preference 4", value: 4 },
  ];

  const { preferenceWiseReportForAllCourses } = useSelector(
    (state) => state.customerReducer
  );

  useEffect(() => {
    setPreference(1);
    localStorage.removeItem("preferenceWiseReportForAllCourses");
  }, []);

  const onChangePreference = (event) => {
    setPreference(event.target.value);
    setPreference(event.target.value);
  };

  const handleGenerate = () => {
    const formData = {
      preference: preference,
    };
    localStorage.setItem(
      "preferenceWiseReportForAllCourses",
      JSON.stringify(formData)
    );

    dispatch({
      type: customerActions.GET_PREFERENCEWISE_REPORT_FOR_ALL_COURSES,
      payload: {
        preference: preference,
      },
    });
  };

  useEffect(() => {
    const removeLocalStorage = () => {
      localStorage.removeItem("preferenceWiseReportForAllCourses");
    };

    window.addEventListener("beforeunload", removeLocalStorage);

    return () => {
      window.removeEventListener("beforeunload", removeLocalStorage);
    };
  }, []);

  const districtNames = preferenceWiseReportForAllCourses?.length
    ? Object.keys(preferenceWiseReportForAllCourses[0]).filter(
        (k) => k !== "preference_no" && k !== "Exam / Course name"
      )
    : [];

  const applicationStatusColumns = [
    {
      name: "Preference",
      dataIndex: "preference_no",
    },
    {
      name: "Exam / Course Name",
      dataIndex: "course_name",
    },
    ...districtNames.map((district) => ({
      name: district,
      dataIndex: district,
    })),
  ];

  const applicationStatusData = Array.isArray(preferenceWiseReportForAllCourses)
    ? preferenceWiseReportForAllCourses.map((row) => {
        const mappedRow = {
          preference_no: row.preference_no,
          course_name: row["Exam / Course name"],
        };

        districtNames.forEach((district) => {
          mappedRow[district] = Number(row[district] || 0);
        });

        return mappedRow;
      })
    : [];

  const safeTableData = applicationStatusData || [];

  const buildCsvHeaders = () => {
    return [["Preference", "Exam / Course Name", ...districtNames].join(",")];
  };

  const buildCsvRows = () =>
    applicationStatusData.map((row) =>
      [
        row.preference_no,
        `"${row.course_name}"`,
        ...districtNames.map((d) => row[d] ?? 0),
      ].join(",")
    );

  const buildTotalRow = () => {
    const totals = {};

    districtNames.forEach((d) => {
      totals[d] = applicationStatusData.reduce(
        (sum, r) => sum + Number(r[d] || 0),
        0
      );
    });

    return ["TOTAL", "", ...districtNames.map((d) => totals[d])].join(",");
  };

  const downloadPreferenceWiseReport = () => {
    const headers = buildCsvHeaders();
    const rows = buildCsvRows();
    const totalRow = buildTotalRow();

    const csvContent = [...headers, ...rows, totalRow].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute(
      "download",
      `preference-wise-report-for-allcourses-${preference}-${Date.now()}.csv`
    );

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography>Preference Wise Report For All Courses</Typography>
          </Box>
          <Grid item sm={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gap: 2, flexWrap: "wrap", mt: 2, alignItems: "center" }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                sx={{ gap: 2, flexWrap: "wrap", mt: 2 }}
              >
                {/* select preference  */}
                <FormControl sx={{ width: "220px" }}>
                  <Select
                    size="small"
                    value={preference}
                    onChange={onChangePreference}
                    sx={{ height: "56px" }}
                  >
                    <MenuItem value="" disabled>
                      Select Preference
                    </MenuItem>
                    {preferencesno.map((pref) => (
                      <MenuItem key={pref.value} value={pref.value}>
                        {pref.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ marginTop: 1, display: "flex", gap: 2 }}>
                <BluePrimaryButton
                  title={"Generate"}
                  handleSubmit={handleGenerate}
                />
                <Button
                  variant="contained"
                  color="success"
                  onClick={downloadPreferenceWiseReport}
                  sx={{ height: "40px" }}
                >
                  Export To CSV
                </Button>
              </Box>
            </Box>
          </Grid>

          <Box sx={{ marginTop: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "500",
                color: "black",
                fontSize: "20px",
                lineHeight: "24px",
                mb: 2,
                backgroundColor: "whitesmoke",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              Preference Wise Report For All Courses
            </Typography>
          </Box>
          <PreferenceWiseTableForAllCourses
            columnData={applicationStatusColumns}
            tableData={safeTableData}
          />
        </Card>
      </Box>
    </>
  );
}
